import React from 'react';
import { useNavigate } from 'react-router-dom';

const Welcome = () => {
  const navigate = useNavigate();

  // Safely parse user from localStorage
  const getUser = () => {
    try {
      const userString = localStorage.getItem('user');
      if (!userString || userString === 'undefined' || userString === 'null') {
        return {};
      }
      return JSON.parse(userString);
    } catch (error) {
      console.error('Error parsing user data:', error);
      return {};
    }
  };

  const user = getUser();
  const userName = user?.fullName || user?.name || 'Admin';

  const handleCardClick = (path) => {
    navigate(path);
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      padding: '40px 20px',
      textAlign: 'center'
    }}>
      <h1 style={{
        fontSize: '36px',
        fontWeight: '600',
        color: '#101010',
        marginBottom: '16px'
      }}>
        Welcome, {userName}!
      </h1>
      <p style={{
        fontSize: '18px',
        color: '#666',
        marginBottom: '32px',
        maxWidth: '600px'
      }}>
        Welcome to the Junction Admin Portal. Select a category from the left menu to view detailed insights and metrics.
      </p>
      <div style={{
        display: 'flex',
        gap: '20px',
        marginTop: '20px',
        flexWrap: 'wrap',
        justifyContent: 'center'
      }}>
        <div 
          onClick={() => handleCardClick('/dashboard/user-metrics')}
          style={{
            padding: '24px',
            backgroundColor: '#fff',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            minWidth: '200px',
            border: '2px solid #e8e8e8',
            cursor: 'pointer',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = '#ff6705';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(255, 103, 5, 0.2)';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = '#e8e8e8';
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          <h3 style={{ fontSize: '20px', marginBottom: '8px', color: '#101010' }}>User Metrics</h3>
          <p style={{ fontSize: '14px', color: '#666', margin: 0 }}>
            View user statistics, activity, and verification status
          </p>
        </div>
        <div 
          onClick={() => handleCardClick('/dashboard/marketplace-metrics')}
          style={{
            padding: '24px',
            backgroundColor: '#fff',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            minWidth: '200px',
            border: '2px solid #e8e8e8',
            cursor: 'pointer',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = '#ff6705';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(255, 103, 5, 0.2)';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = '#e8e8e8';
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          <h3 style={{ fontSize: '20px', marginBottom: '8px', color: '#101010' }}>Marketplace Metrics</h3>
          <p style={{ fontSize: '14px', color: '#666', margin: 0 }}>
            Track listings, sales, and marketplace performance
          </p>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
